import { authApiInstance } from './api'

export const authService = {
  login: (credentials) => authApiInstance.post('/auth/login', credentials),
  refreshToken: (tokenData) => authApiInstance.post('/auth/refresh-token', tokenData),
  forgotPassword: (email) => authApiInstance.post('/auth/forgot-password', { email }),
  resetPassword: (resetData) => authApiInstance.post('/auth/reset-password', resetData),
  externalLogin: (data) => authApiInstance.post('/auth/external-login', data),
}

// Token management
export const tokenManager = {
  getToken: () => localStorage.getItem('authToken'),
  getRefreshToken: () => localStorage.getItem('refreshToken'),
  setTokens: (token, refreshToken) => {
    localStorage.setItem('authToken', token)
    if (refreshToken) {
      localStorage.setItem('refreshToken', refreshToken)
    }
  },
  clearTokens: () => {
    localStorage.removeItem('authToken')
    localStorage.removeItem('refreshToken')
    localStorage.removeItem('userProfile')
  },
  getUserProfile: () => {
    const profile = localStorage.getItem('userProfile')
    return profile ? JSON.parse(profile) : null
  },
  setUserProfile: (profile) => {
    localStorage.setItem('userProfile', JSON.stringify(profile))
  }
}
